<i18n lang="yaml">
  en:
    close: Close
  fr:
    close: Fermer
</i18n>

<template>
  <modal
    :name="name"
    :adaptive="true"
    :scrollable="true"
    :width="width"
    :max-width="maxWidth"
    height="auto"
    :classes="['modal', 'v--modal']"
    v-on="$listeners"
  >
    <div
      :class="[
        'space-pt-4--xxs',
        'space-pt-7--l',
        'space-pb-5--xxs',
        'space-pb-8--l',
      ]"
    >
      <button class="modal__close btn btn--icon btn--tertiary" @click="$modal.hide(name)">
        <span class="display-hidden-accessible">{{ $t('close') }}</span>
        <vue-icon name="icon-close" />
      </button>

      <header v-if="$slots.header || title" class="space-pb-2--xxs space-pb-3--m">
        <!-- @slot Modal header -->
        <slot name="header">
          <h2 v-if="title" class="type-title-secondary">{{ title }}</h2>
        </slot>
      </header>

      <article v-if="$slots.content">
        <!-- @slot Modal content -->
        <slot name="content" />
      </article>

      <footer v-if="$slots.footer" class="space-pt-4--xxs space-pt-7--l">
        <!-- @slot Modal footer -->
        <slot name="footer" />
      </footer>
    </div>
  </modal>
</template>

<script>
import VueIcon from '~/components/Icon';

export default {
  name: 'DefaultModal',
  components: {
    VueIcon,
  },
  props: {
    /**
     * The displayed title of the modal.
     */
    title: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * The name of the modal.
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * The width of the modal.
     * Default value: 10 columns width.
     */
    width: {
      type: String,
      required: false,
      default: `${10 * (100 / 12)}%`,
    },
    /**
     * The max-width of the modal.
     * Default value: page-center width.
     */
    maxWidth: {
      type: Number,
      required: false,
      default: 1216,
    },
  },
};
</script>

<style lang="scss">
.modal__close {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate3d(50%, -50%, 0);
}

.v--modal-overlay {
  background: transparentize(color('blue'), 0.2);
}

.v--modal {
  margin-top: space(8);
  margin-bottom: space(8) !important;
  border-radius: 5px;
}

.v--modal-overlay .v--modal-box {
  overflow: visible !important;
}

.modal__close path {
  stroke: c('white');
}
</style>
